import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavLink,
} from 'reactstrap';
import { useOrderAlerts } from '../../contexts/OrderAlertsContext';
import { ApiContext } from '../../contexts/ApiContext';
import { accountPath } from '../../utils/accountPath';

const OrderAlertBell = () => {
  const navigate = useNavigate();
  const { account } = useContext(ApiContext);
  const { pendingCount, staleCount, soundMuted, toggleSoundMuted } = useOrderAlerts();

  const badgeCount = staleCount > 0 ? staleCount : pendingCount;
  const badgeClass = staleCount > 0 ? 'order-alert-bell__badge--danger' : 'order-alert-bell__badge--warning';

  return (
    <UncontrolledDropdown nav>
      <DropdownToggle caret color="default" nav>
        <span className="order-alert-bell">
          <i className={`tim-icons ${soundMuted ? 'icon-button-pause' : 'icon-bell-55'}`} />
          {badgeCount > 0 && (
            <span className={`order-alert-bell__badge ${badgeClass}`}>
              {badgeCount > 99 ? '99+' : badgeCount}
            </span>
          )}
        </span>
        <p className="d-lg-none">Pedidos</p>
      </DropdownToggle>
      <DropdownMenu className="dropdown-navbar order-alert-bell__menu" right tag="ul">
        <NavLink tag="li">
          <DropdownItem header tag="div" className="order-alert-bell__header">
            Alertas de pedidos
          </DropdownItem>
        </NavLink>
        <NavLink tag="li">
          <DropdownItem className="nav-item" toggle={false}>
            {pendingCount} pedido{pendingCount !== 1 ? 's' : ''} aguardando
          </DropdownItem>
        </NavLink>
        {staleCount > 0 && (
          <NavLink tag="li">
            <DropdownItem className="nav-item text-warning" toggle={false}>
              {staleCount} parado{staleCount !== 1 ? 's' : ''} há 10+ min
            </DropdownItem>
          </NavLink>
        )}
        <DropdownItem divider tag="li" />
        <NavLink tag="li">
          <DropdownItem
            className="nav-item"
            onClick={() => navigate(accountPath(account?.id, '/pedidos'))}
          >
            Ir para pedidos
          </DropdownItem>
        </NavLink>
        <NavLink tag="li">
          <DropdownItem className="nav-item" onClick={toggleSoundMuted}>
            {soundMuted ? 'Ativar sons' : 'Silenciar sons'}
          </DropdownItem>
        </NavLink>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default OrderAlertBell;
